import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-950 px-4 pb-28 pt-12 text-center sm:px-6 sm:pb-32" data-id="element-124" data-mp="32wd2qgad7ltj">
      <p className="font-display text-lg font-bold text-white sm:text-xl" data-id="element-125" data-mp="3ggty8ibanj58">
        Ruta Fertilidad Masculina
      </p>
      <p className="mt-1 text-[12px] font-semibold uppercase tracking-widest text-gold-400 sm:text-sm" data-id="element-126" data-mp="32lrkj907gphv">
        Dra. Karito
      </p>
      <p className="mx-auto mt-5 max-w-xl text-[11.5px] leading-relaxed text-white/50 sm:text-[13px]" data-id="element-127" data-mp="3ufa6idot1hph">
        Este material es un recurso educativo dirigido a profesionales de la salud. No reemplaza la
        formación especializada, el juicio clínico ni las guías oficiales vigentes.
      </p>
      <p className="mt-4 text-[11px] text-white/35 sm:text-xs" data-id="element-128" data-mp="3qd6sbhar3z0i">
        © {new Date().getFullYear()} Ruta Fertilidad Masculina · Todos los derechos reservados
      </p>
    </footer>;
}